import React from 'react';
import { HeaderAndContainer } from '@trucktrax/trucktrax-common';
import { Card, CardContent } from '@mui/material';
import styles from './UserGuidesCommon.module.css';
import Header from '../../../shared/Header';
import AdminCardStyles from '../../../shared/admin/AdminCard.module.css';
import CardImage from '../../../shared/forms/CardImage';
import DocsTable from '../../../shared/docs/DocsTable';
import userGuidesTruckTraxGeoPng from '../../../../assets/img/userGuidesTruckTraxGeo.png';
import { TRUCKTRAX_GEO_USERGUIDES_FOLDER } from '../../../../constants/docsConstants';

export function GuideTruckTraxGeoView() {
  const cardStyle = {
    root: AdminCardStyles.card,
  };

  const documents = [
    {
      name: 'Getting Started',
      filepath: `${TRUCKTRAX_GEO_USERGUIDES_FOLDER}userguide_mobile_Getting_Started.pdf`,
    },
    {
      name: 'Admin Guide',
      filepath: `${TRUCKTRAX_GEO_USERGUIDES_FOLDER}userguide_lite_Admin_Guide.pdf`,
    },
    {
      name: 'Driver First Log In',
      filepath: `${TRUCKTRAX_GEO_USERGUIDES_FOLDER}userguide_lite_Driver_First_Log_In.pdf`,
    },
    {
      name: 'Driver Handout',
      filepath: `${TRUCKTRAX_GEO_USERGUIDES_FOLDER}userguide_lite_Driver_Handout.pdf`,
    },
  ];

  const guideBody = (
    <div className={AdminCardStyles.bodyWrapper}>
      <div className={AdminCardStyles.cardWrapper}>
        <Card classes={cardStyle}>
          <CardImage src={userGuidesTruckTraxGeoPng} className={styles.topImg} />
          <CardContent>
            <div className={AdminCardStyles.cardText}>
              <h2 className={styles.header}>TruckTrax Geo User Guide</h2>

              <p>
                TruckTrax Geo® is a cloud-based platform for tracking and managing bulk construction
                material deliveries. The mobile app works on Android® and iOS phones and tablets,
                with no dedicated truck-mounted hardware required. The app connects to a cloud
                database that stores delivery data and supports the web application. The web
                application also integrates with a client’s ticketing software for two-way data
                exchange.
              </p>

              <div className={styles.divider} />
              <DocsTable documents={documents} folder={TRUCKTRAX_GEO_USERGUIDES_FOLDER} />
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );

  const elementsLeft = <Header title="User Guides" />;

  return (
    <div>
      <div>
        <HeaderAndContainer elementsLeft={elementsLeft} />
      </div>
      {guideBody}
    </div>
  );
}

export default GuideTruckTraxGeoView;
